import React from 'react'
import { Base, Button, HTMLText, Icon } from '@crossfit/ui'
import classNames from 'classnames'
import style from './style.module.css'
import { useSelector } from 'react-redux'
import { getBannerState } from 'store/selectors'

export default function NotificationBanner({ className }) {
  const bannerState = useSelector(getBannerState)
  const bannerTypeToIcon = () => {
    switch (bannerState.bannerType) {
      case 'info':
        return 'info'
      case 'warning':
        return 'alert'
      default:
        return 'alert'
    }
  }
  const displayCTAButton: boolean =
    bannerState.buttonText != null &&
    bannerState.buttonText != '' &&
    bannerState.buttonUrl != null &&
    bannerState.buttonUrl != ''

  return (
    <Base
      className={classNames(style.wrapper, className, {
        [style.info]: bannerState.bannerType === 'info',
        [style.warning]: bannerState.bannerType === 'warning',
      })}
    >
      <div className={style.bannerTopRow}>
        <Icon
          name={bannerTypeToIcon()}
          height={16}
          width={16}
          className={classNames(style.icon, {
            [style.info]: bannerState.bannerType === 'info',
            [style.warning]: bannerState.bannerType === 'warning',
          })}
        />
        <HTMLText>{bannerState.bannerMessage}</HTMLText>
      </div>

      {displayCTAButton && (
        <Button
          className={style.button}
          variant='secondary'
          onClick={() => {
            location.href = bannerState.buttonUrl
          }}
        >
          {bannerState.buttonText}
        </Button>
      )}
    </Base>
  )
}
